// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__pSI-u","inner":"Footer_inner__ih0ZJ"};